export const TYPE_SCOUT = 1;
export const TYPE_APPLY = 2;
